import { IAppReduxState } from '../models';
import { AuthService } from '../services/auth-service';

export const getInitialAppReduxState = (): IAppReduxState => {
  const authToken = AuthService.getAuthToken();
  const testingDashboardAuthToken = AuthService.getTestingDashboardAuthToken();
  const refreshToken = AuthService.getRefreshToken();
  return {
    account: {
      accountNumber: '',
      customerName: '',
      stateCode: undefined ?? '',
      servicePoints: [],
    },
    core: {
      isAuthenticated: !!authToken,
      isTestingDashboardAuthenticated: !!testingDashboardAuthToken,
      token: authToken ?? '',
      testingDashboardToken: testingDashboardAuthToken ?? '',
      refreshToken: refreshToken ?? '',
      currentTime: 0,
      tokenExp: 0,
    },
    bill: {
      estimations: {},
    },
    visualizer: {
      visualizerOverviewData: {},
      visualizerDetailsData: {},
    },
    userInput: {
      selectedPlan: '',
      selectedMeterID: '',
    },
  };
};
